export default {
  data() {
    return {
      vaginalBleeding: {
        0: "None",
        20: "Brown-tinged discharge",
        40: "Spotting or bloody streaks",
        60: "Light bleeding",
        80: "Moderate bleeding",
        100: "Heavy bleeding",
      },
      saturation: {
        100: "< 1 Hour",
        66: "1 - 2 Hours",
        33: "3 - 4 Hours",
        0: "> 4 Hours",
      },
    };
  },

  methods: {
    getVaginalBleedingValueName(value) {
      return this.vaginalBleeding[value];
    },

    getSaturationValueName(value) {
      return this.saturation[value];
    },
  },
};
